import BrandIconBlack from '../icons/brand-icon-black';

const AuthHeader = () => {
  return (
    <div className="flex items-center justify-between gap-2 text-grey-900">
      <BrandIconBlack className="w-[93px] h-6 md:w-[124px] md:h-8" />
    </div>
  );
};

export { AuthHeader };
